import { DividerElement } from '@typedream/components';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_DIVIDER } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';

export const createDividerPlugin = createTElementPluginFactory({
  key: ELEMENT_DIVIDER,
  component: withDropTarget(DividerElement),
  isVoid: true,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/divider.png',
      title: 'Divider',
      subtitle: 'A line to divider contents',
      keywords: ['divider', 'line', 'hr'],
    },
    format: {
      formatType: 'block',
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['width', 'mobile_hide', 'desktop_hide', 'margin'],
      validChildrenTypes: [],
    },
  },
});
